import { Routes } from '@angular/router';

export const leapmotorzoneroutes: Routes = [
    { path: 'mkt-coop', loadChildren: () => import('./mkt-coop/mkt-coop.module').then(m => m.MktCoopModule), data: { animation: 'mkt-coop', roles: ['ADMINISTRADOR', 'LEAPMOTOR'] } },
    { path: 'campaign', loadChildren: () => import('./campaign/campaign.module').then(m => m.AdmCampaignModule), data: { animation: 'campaign', roles: ['ADMINISTRADOR', 'LEAPMOTOR'] } }
]
